import { render, staticRenderFns } from "./_Produksi.vue?vue&type=template&id=1657efa0&"
import script from "./_Produksi.vue?vue&type=script&lang=js&"
export * from "./_Produksi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports